import {
  GET_BOARDS,
  GET_BOARDS_FAILED,
  GET_BOARDS_REQUEST,
  ADD_NEW_BOARD_REQUEST,
  ADD_NEW_BOARD_SUCCESS,
  ADD_NEW_BOARD_FAILD,
  WALLET_VALUE_REQUEST,
  WALLET_VALUE_SUCCESS,
  WALLET_VALUE_FAILD,
  USER_INFO_SUCCESS,
  GET_TASK_CATEGORIES_PERSONAL,
  USER_PERSONAL_TASKS,
  USER_PERSONAL_RTLDIR_TASKS,
  SELECTED_FILTERS_PERSONAL_TASKS,
  GET_USER_NOTIFICATIONS_SUCCESS,
  GET_USER_PEYMENTS_SUCCESS,
  USER_PERSONAL_TASK_UPDATED,
  USER_BOARD_ANSWARE,
  USER_AFFILIATE_DATA,
  GET_WEEK_TASKS,
  GET_MONTH_TASKS,
  GET_SITE_CALENDAR,
  GET_USER_SETTINGS,
  OPEN_RECENT_TASK,
  GET_ALL_USER_TASKS,
  USER_PERSONAL_WEEKLY_PLAN,
} from "./DashboardType";
import { UPDATE_USER_INFO_SUCCESS } from "../Users/UserProfile/userProfileTypes";
import { mergeUserPatch } from "../Users/UserProfile/mergeUserUpdate";

export const GetUserBoardsReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_BOARDS_REQUEST: {
      return {
        Loading: true,
        data: [],
      };
    }
    case GET_BOARDS: {
      return {
        Loading: false,
        data: action.payload,
      };
    }
    case ADD_NEW_BOARD_REQUEST: {
      return {
        ...state,
        AddingBoard: true,
      };
    }
    case ADD_NEW_BOARD_SUCCESS: {
      return {
        ...state,
        AddingBoard: false,
        data: [action.payload, ...state.data],
      };
    }
    case ADD_NEW_BOARD_FAILD: {
      return {
        ...state,
        AddingBoard: false,
      };
    }
    case USER_BOARD_ANSWARE: {
      const Boards1 = state.data;
      if (!Array.isArray(Boards1)) return state;
      if (action.Payload.Joined) {
        const Find1 = Boards1.find(
          (item) => item.BoardID === action.Payload.BoardID
        );
        if (!Find1) return state;
        Find1.Joined = action.Payload.Joined;
        return {
          ...state,
          data: [...Boards1],
        };
      } else {
        const Filter1 = Boards1.filter(
          (item) => item.BoardID !== action.Payload.BoardID
        );
        return {
          ...state,
          data: [...Filter1],
        };
      }
    }
    default: {
      return state;
    }
  }
};

export const UserWalletValueReducer = (WalletValue = "", action) => {
  switch (action.type) {
    case WALLET_VALUE_REQUEST: {
      return { Loading: true, WalletValue: "" };
    }
    case WALLET_VALUE_SUCCESS: {
      return { Loading: false, WalletValue: action.Payload };
    }
    default: {
      return WalletValue;
    }
  }
};

export const UserInfoReducer = (
  state = { Loading: true, data: {} },
  action
) => {
  switch (action.type) {
    case USER_INFO_SUCCESS: {
      return { Loading: false, data: { ...action.Payload } };
    }
    case GET_USER_SETTINGS: {
      const dataNew1 = state.data;
      dataNew1.Settings = action.Payload;
      return { ...state, data: { ...dataNew1 } };
    }
    case UPDATE_USER_INFO_SUCCESS: {
      const payload = action.payload?.body ?? action.payload;
      const userUpdates = payload?.user;
      if (!userUpdates) return state;
      return {
        ...state,
        data: mergeUserPatch(state.data, userUpdates),
      };
    }
    default: {
      return state;
    }
  }
};

export const UserTasksReducer = (
  state = {
    Loading: true,
    Categories: [],
    Tasks: [],
    WeeklyPlans: undefined,
    RTLDir: false,
    Filter: null,
    AllTasks: [],
  },
  action
) => {
  switch (action.type) {
    case GET_TASK_CATEGORIES_PERSONAL: {
      return { Loading: false, Categories: action.Payload };
    }
    case USER_PERSONAL_TASKS: {
      return { Loading: false, Tasks: action.Payload };
    }
    case USER_PERSONAL_RTLDIR_TASKS: {
      return { RTLDir: action.Payload };
    }
    case SELECTED_FILTERS_PERSONAL_TASKS: {
      return { Filter: action.Payload };
    }
    case USER_PERSONAL_TASK_UPDATED: {
      return { Loading: false, Tasks: action.Payload };
    }
    case USER_PERSONAL_WEEKLY_PLAN: {
      return { Loading: false, WeeklyPlans: action.Payload };
    }
    case GET_ALL_USER_TASKS: {
      return { ...state, Loading: false, AllTasks: action.Payload };
    }
    default: {
      return state;
    }
  }
};

export const getUserNotificationsReducer = (
  state = {
    Loading: true,
    Notifs: [],
  },
  action
) => {
  switch (action.type) {
    case GET_USER_NOTIFICATIONS_SUCCESS: {
      return { Loading: false, Notifs: action.Payload };
    }
    default: {
      return state;
    }
  }
};

export const getUserPaymentsReducer = (
  state = {
    Loading: true,
    Payments: [],
  },
  action
) => {
  switch (action.type) {
    case GET_USER_PEYMENTS_SUCCESS: {
      return { Loading: false, Payments: action.Payload };
    }
    default: {
      return state;
    }
  }
};

export const getUserAffiliatesReducer = (
  state = {
    Loading: true,
    AffiliateData: [],
  },
  action
) => {
  switch (action.type) {
    case USER_AFFILIATE_DATA: {
      return {
        ...state,
        Loading: false,
        AffiliateData: action.Payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const RecentTasks = (
  state = {
    Loading: true,
    MonthTasks: [],
    UserAllTasks: [],
    OpenTaskBody: {},
  },
  action
) => {
  switch (action.type) {
    case GET_MONTH_TASKS: {
      return {
        ...state,
        Loading: false,
        MonthTasks: action.Payload,
      };
    }
    case GET_ALL_USER_TASKS: {
      return {
        ...state,
        Loading: false,
        UserAllTasks: action.Payload,
      };
    }
    case OPEN_RECENT_TASK: {
      return {
        ...state,
        OpenTaskBody: action.Payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const UserSettings = (
  state = { SiteLanguage: "", SiteCalendar: "" },
  action
) => {
  switch (action.type) {
    case GET_SITE_CALENDAR: {
      return {
        ...state,
        SiteCalendar: action.Payload,
      };
    }
    case GET_USER_SETTINGS: {
      return {
        ...state,
        ...action.Payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const tetherPriceReducer = (
  state = { tetherPrice: { usd: null, toman: null } },
  action
) => {
  switch (action.type) {
    case "FETCH_TETHER_PRICE":
      return { tetherPrice: action.payload };
    default:
      return state;
  }
};
